export enum GradientType {
  None,
  Solid,
  Gradient,
  Picture
}
